import request from '@/utils/request'


// 查询商场门店列表
export function listMallStore(query) {
  return request({
    url: '/store/mall/store/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商场门店分页
export function pageMallStore(query) {
  return request({
    url: '/store/mall/store/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商场门店详细
export function getMallStore(data) {
  return request({
    url: '/store/mall/store/detail',
    method: 'get',
    params: data
  })
}

// 新增商场门店
export function addMallStore(data) {
  return request({
    url: '/store/mall/store/add',
    method: 'post',
    data: data
  })
}

// 修改商场门店
export function updateMallStore(data) {
  return request({
    url: '/store/mall/store/edit',
    method: 'post',
    data: data
  })
}

// 删除商场门店
export function delMallStore(data) {
  return request({
    url: '/store/mall/store/delete',
    method: 'post',
    data: data
  })
}
